import React from "react";
import { useNavigate } from "react-router-dom";

const ItemBody15 = ({ notification }) => {
  const navigate = useNavigate();

  return (
    <div>
      <p className="font-poppins text-xs font-light text-black">
        Insufficient energy at{" "}
        <span className="font-medium capitalize">
          {notification?.metaData?.hubName}
        </span>{" "}
        for upcoming sessions.
      </p>

      <div className="mt-1 w-full flex items-center gap-x-2">
        <button
          type="button"
          className="bg-primary hover:bg-primary-50 py-2 px-4 rounded-md w-full"
          onClick={() => navigate("/hubs")}
        >
          <p className="font-poppins text-xs font-medium text-background-white text-center">
            Go To Hub
          </p>
        </button>
      </div>
    </div>
  );
};

export default ItemBody15;
